// Import directo (no vía barrel `@/atoms`): este módulo ya vive en el ciclo
// templates ↔ dynamic-components y no hace falta arrastrar todos los atoms.
import ScrollReveal from '@/atoms/scroll-reveal';

import * as Components from '@/components/dynamic-components';

import type { TypeAnimacion } from '@/atoms/scroll-reveal';
import type { FunctionComponent } from 'react';
import type { TypeDynamicComponentsProps } from './types';

/**
 * DynamicComponents
 *
 * Toggle `HideOnMobile` (boolean en cualquier bloque de `revisadas.*`) hace
 * que el bloque se oculte hasta md (≥768px). Sin pick = legacy intacto.
 * Lo aplicamos vía wrapper para no tener que threadear el flag por cada
 * componente.
 *
 * Igual con `Animacion` (componente `revisadas.animacion`): la animación de
 * entrada al hacer scroll se aplica envolviendo el bloque en `ScrollReveal`,
 * así los 24 componentes de `dynamic-components/` no se enteran. Sin `Efecto`
 * el wrapper ni siquiera se pinta.
 */
export const DynamicComponents: FunctionComponent<
  TypeDynamicComponentsProps & {
    HideOnMobile?: boolean;
    Animacion?: TypeAnimacion | null;
  }
> = ({
  className = '',
  type,
  HideOnMobile,
  Animacion,
  ...props
}: TypeDynamicComponentsProps & {
  HideOnMobile?: boolean;
  Animacion?: TypeAnimacion | null;
}) => {
  const Component = (Components[type as keyof typeof Components] ??
    null) as React.ComponentType<any> | null;
  if (!Component) return Component;
  const node = (
    <Component {...props} className={className} componentType={type} />
  );
  const revealed = <ScrollReveal animacion={Animacion}>{node}</ScrollReveal>;
  return HideOnMobile ? (
    <div className="hidden md:block">{revealed}</div>
  ) : (
    revealed
  );
};

DynamicComponents.displayName = 'DynamicComponents';
